import React from 'react';
import { useTranslation } from 'react-i18next';
import TableLabel from '../HistoryBatchTableLabel';

const HistoryBatchTableHeader = () => {
  const { t, ready } = useTranslation(['history', 'history']);

  if (!ready) {
    return <div>Carregando tradução...</div>;
  }

  return (
    <tr className="table-beneficiaries-header">
      <th>
        <TableLabel />
      </th>
      <th className="history-label">{t('history:code')}</th>
      <th className="history-label">{t('history:status')}</th>
    </tr>
  );
};

export default HistoryBatchTableHeader;
